<template>
  <div>
    <div id="list-container" v-if="listtype === 'picture-card'" class="downloadable-list-container">
      <ul class="downloadable-list">
        <li v-for="file in downloadableList" :key="file.id" class="downloadable-list-item">
          <a :href="file.urlorig" :download="file.name" target="_blank">{{ displayFileName(file.name) }}</a>
          <div class="button-container">
            <el-button v-if="!cntrldisabled" size="small" style="text-align: right" @click="handleRemove(file, $event)"><i
                class="fa-solid fa-trash-can"></i></el-button>
          </div>
        </li>
      </ul>
    </div>
    <div :class="{ 'hide': cntrldisabled }">

      <el-upload :class="{ 'custom-upload': listtype === 'text' }" v-loading="loading" ref="upload" :headers="uploadHeaders"
        :disabled="cntrldisabled" :action="cntrluploadapi" :list-type="listtype" :auto-upload="cntrlautoupload" multiple
        :limit="60" :file-list="fileList" :on-preview="onPreview2" :before-remove="beforeRemove"
        :before-upload="beforeUpload" :on-success="afterUpload" :on-remove="handleRemove"
        :accept="acceptonlyimages ? imageonly : '*'">
        <i slot="default" class="el-icon-plus" v-if="listtype === 'picture-card'" />
        <div slot="file" slot-scope="{ file }" v-if="listtype === 'picture-card'">
          <div @click="onPreview2(file)">
            <img class="el-upload-list__item-thumbnail" :src="isVideo(file) ? videothumb : file.urlorig" alt="" />
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview large-icon-button" @click="onPreview2(file)"><i
                  class="el-icon-zoom-in" /></span>
              <span v-if="!disabled" class="el-upload-list__item-delete large-icon-button"
                @click.stop="handleRemove(file, $event)"><i class="el-icon-delete" /></span>
            </span>
          </div>
        </div>
        <el-button slot="trigger" size="small" type="primary" v-if="listtype === 'text' && !cntrldisabled">Faylı əlavə
          et</el-button>
      </el-upload>

    </div>
    <div style="text-align: center; width: 100%" v-if="downloadAll && fileList.length > 0">
      <el-button size="medium" type="text" @click.native="click" :loading="downloading"><i class="el-icon-download"></i>
       {{$t('Hamısını_yüklə')}}</el-button>
    </div>
    <el-dialog class="custom-dialog" width="90%" top="5vh" :visible.sync="dialogVisible" :center="true" append-to-body>
      <upload-preview :selectedIndex="selectedIndex" :images="fileList.filter((c) => c.url !== this.videothumb)" />
    </el-dialog>
    <el-dialog class="custom-dialog" width="90%" top="5vh" :visible.sync="dialogVideoVisible" :center="true"
      append-to-body :destroy-on-close="true">
      <upload-video :url="selectedVideo" />
    </el-dialog>
  </div>
</template>


<script>
import { GenerateHex } from "../../services/crypto";
import { api, fileurl } from "../../services/helper";
import { InsertFile, GetFiles, DeleteFile } from "../../services/files";
import { FileType } from "../../services/types";
import UploadPreview from "./UploadPreview";
import UploadVideo from "./UploadVideo";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import saveAs from "save-as";
export default {
  name: "upload",
  computed: {
    cntrluploadapi() {
      return api + "/Upload";
    },

  },
  components: {
    UploadPreview,
    UploadVideo,
  },
  props: {
    sourcetype: Number,
    sourceId: [Number, String],
    uploadapi: {
      type: String,
      default: "/",
    },
    fileurl: { type: String, default: fileurl },
    disabled: { type: Boolean, default: false },
    autoupload: { type: Boolean, default: true },
    listtype: { type: String, default: "picture-card" },
    downloadAll: { type: Boolean, default: false },
    acceptonlyimages: { type: Boolean, default: true },
  },
  data() {
    return {
        uploadingCount: 0,
  insertingCount: 0,
      imageonly: ".jpg,.jpeg,.png,.jfif,.mp4,.mkv,.mov,.html,.xhtml,.doc,.xls,.xlsx,.pdf",
      progress: 0,
      fileList: [],
      loading: false,
      downloading: false,
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVideoVisible: false,
      selectedIndex: 0,
      cntrlfileurl: this.fileurl,
      // cntrluploadapi: this.uploadapi,
      cntrldisabled: this.disabled,
      cntrlautoupload: this.autoupload,
      sid: this.sourceId,
      sdid: this.sourcedetId,
      filecount: 0,
      previewlist: [],
      zip: "",
      count: 0,
      fileURLs: [],
      selectedVideo: "",
      video: ["mp4", "mkv", "mov"],
      videothumb: "https://carep.hu-st.com/_assets/thumb_video.png",
      uid: this.$store.state.user.id,
      downloadableList: [], // New list for downloadable files
      uploadHeaders: {
      Authorization: 'Bearer ' + this.$store.state.user.jwt,
    },
    };
  },
  methods: {
    isFileType(fileName, extension) {
      return fileName.endsWith('.' + extension);
    },
    isVideo(file) {
      if (!file || !file.rawname) return false;
      let ext = file.rawname.split(".").pop().toLowerCase();
      return this.video.includes(ext);
    },
    submit(sourceId, sourcedetId) {
      this.sid = sourceId;
      this.sdid = sourcedetId;
      this.$refs.upload.submit();
    },
    handleRemove(file, event) {
      if (event && event.stopPropagation) {
        event.stopPropagation();
      }
      if (!file.id) return;
      
      this.$confirm(this.$t('Ləğv_olunsun'), this.$t('Təsdiqləyin'), {
        cancelButtonText: this.$t('Xeyr'),
        confirmButtonText: this.$t('Bəli'),
        type: "warning",
        customClass: 'reverse-buttons'
      })
        .then(() => {
          DeleteFile(file.id, this.uid).then((response) => {
            this.loading = false;
            if (response.data?.isSuccess) {
              this.$message({
                type: "success",
                message: this.$t('Ləğv_olundu'),
              });
              this.getFiles();
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Xitam verildi",
          });
        });
    },
    beforeRemove(file, fileList) {
      if (this.listtype === 'picture-card') {
        if (!this.downloadableList.includes(file)) {

          return confirm(`Ləğv olunsun?`)
            ;
        }

      }

    },
    onPreview(file) {
      if (this.listtype === "picture-card") {
        this.selectedIndex = this.fileList.indexOf(file);
        this.dialogVisible = true;
        this.previewlist.push(file.urlorig);
        if (this.$refs.carousel)
          this.$refs.carousel.setActiveItem(this.selectedIndex);
      } else {
        window.open(file.url, "_blank");
      }
    },

    onPreview2(file) {
      let ext = file.rawname.split(".").pop();
      if (this.listtype === "picture-card") {
        if (this.video.includes(ext.toLowerCase())) {
          this.selectedVideo = file.urlorig;
          this.dialogVideoVisible = true;
        } else if (['jpg', 'jpeg', 'png','jfif'].includes(ext.toLowerCase())) {
          this.selectedIndex = this.fileList
            .filter((c) => c.url !== this.videothumb)
            .indexOf(file);
          this.dialogVisible = true;
          this.previewlist = [];
          this.fileList
            .filter((c) => c.url !== this.videothumb)
            .forEach((e) => this.previewlist.push(e.urlorig));
        }
      } else {
        window.open(file.urlorig, "_blank");
      }
    },

beforeUpload(file) {
  let fname = file.name;
  let key = GenerateHex();
  let newname = key + "_" + fname;

  Object.defineProperty(file, "name", {
    writable: true,
    value: newname,
  });

  this.uploadingCount++;
  this.filecount = this.filecount + 1; // istəyirsən saxla, amma əsas olan uploadingCount-dur
},

afterUpload(uploadResp, file, fileList) {
  // Upload endpoint cavabı
  if (!uploadResp || !uploadResp.dbPath) {
    this.uploadingCount = Math.max(0, this.uploadingCount - 1);
    this.filecount = Math.max(0, this.filecount - 1);
    return;
  }

  const f = new FileType();
  f.filename = file.raw.name; // newname artıq burdadır
  f.sourcetype = this.sourcetype;
  f.sourceId = this.sid;
  f.commandUserId = this.uid;

  // ✅ ÇOX VACİB: serverin verdiyi yolu DB insertə ötür
  // Backend hansı field gözləyirsə onu uyğunlaşdır:
  f.dbPath = uploadResp.dbPath;
  if (uploadResp.url) f.url = uploadResp.url;

  this.insertingCount++;
  this.loading = true;

  InsertFile(f)
    .then((res) => {
      const ok = !!(res?.data?.isSuccess ?? res?.data?.IsSuccess);

      this.insertingCount = Math.max(0, this.insertingCount - 1);
      this.uploadingCount = Math.max(0, this.uploadingCount - 1);
      this.filecount = Math.max(0, this.filecount - 1);

      // ✅ Hamısı bitəndə 1 dəfə serverdən yenilə
      if (this.uploadingCount === 0 && this.insertingCount === 0) {
        // Element UI bəzən internal list saxlayır — təmizləyək
        if (this.$refs.upload) this.$refs.upload.clearFiles();

        // dərhal yenilə
        this.getFiles();
      }
    })
    .catch(() => {
      this.insertingCount = Math.max(0, this.insertingCount - 1);
      this.uploadingCount = Math.max(0, this.uploadingCount - 1);
      this.filecount = Math.max(0, this.filecount - 1);
    })
    .finally(() => {
      if (this.uploadingCount === 0 && this.insertingCount === 0) {
        this.loading = false;
      }
    });
},

    displayFileName(fileName) {
      const extension = fileName.split('.').pop();
      if (['html','xhtml', 'doc', 'xls', 'xlsx', 'pdf'].includes(extension)) {
        return fileName.slice(0, -extension.length - 1);
      }
      return fileName;
    },
    getFiles() {
      if (!this.cntrlfileurl) return;

      this.loading = true;
      GetFiles(this.sourcetype, this.sid, null, this.uid).then((response) => {
        this.fillList(response.data.data);
        this.$emit("filesloaded");
        this.loading = false;
      });
    },
 fillList(files) {
  const newFileList = [];
  const newDownloadableList = [];

  if (!files) {
    this.fileList = [];
    this.downloadableList = [];
    return;
  }

  for (let i = 0; i < files.length; i++) {
    let fname = files[i].fileName.substring(files[i].fileName.indexOf("_") + 1);
    const ext = (files[i].fileName.split(".").pop() || "").toLowerCase();

    const baseFile = {
      name: fname,
      year: files[i].year,
      month: files[i].month,
      id: files[i].id,
      rawname: files[i].fileName,
      urlorig: files[i].url,
    };

    if (this.listtype === "picture-card") {
      // şəkil/video -> galereya
      if (['jpg', 'jpeg', 'png', 'jfif', 'mp4', 'mkv', 'mov'].includes(ext)) {
        let url = "";
        if (this.video.includes(ext)) {
          url = this.videothumb;
        } else {
          // səndə özün path yığırsan, saxlayıram:
          url = this.fileurl + files[i].year + "/" + files[i].month + "/" + files[i].fileName;
        }

        newFileList.push({
          ...baseFile,
          url,
        });
      }

      // pdf/xls/doc/html -> downloadable list
      if (['pdf', 'xls', 'xlsx', 'html', 'xhtml', 'doc', 'docx'].includes(ext)) {
        newDownloadableList.push(baseFile);
      }
    } else {
      // text mode list
      let url = files[i].url;
      if (this.video.includes(ext)) url = this.videothumb;

      newFileList.push({
        ...baseFile,
        url,
      });
    }
  }

  // ✅ reaktiv “new reference”
  this.fileList = newFileList;
  this.downloadableList = newDownloadableList;

  this.$nextTick(() => {});
},

    click() {
      this.downloading = true;
      this.download().then(() => {
        this.downloading = false;
      });
    },

    download() {
      return new Promise((resolve, reject) => {
        let urls = [];
        this.fileURLs = [];
        this.fileList.forEach((element) => {
          urls.push(element.urlorig);
        });

        const zip = new JSZip();
        let count = 0;
        const zipFilename = "cm.zip";
        urls.forEach(async function (url) {
          const urlArr = url.split("/");
          const filename = urlArr[urlArr.length - 1];
          try {
            const file = await JSZipUtils.getBinaryContent(url);
            zip.file(filename, file, {
              binary: true,
            });
            count++;
            if (count === urls.length) {
              zip
                .generateAsync({
                  type: "blob",
                })
                .then(function (content) {
                  saveAs(content, zipFilename);
                  resolve(true);
                });
            }
          } catch (err) {
          }
        });
      });
    },
  },
  mounted() {
    this.uploadHeaders = {
      Authorization: 'Bearer ' + this.$store.state.user.jwt,
    };
    this.getFiles();
  },
  watch: {
    sourceId() {
      this.sid = this.sourceId;
      this.getFiles();
    },
    fileurl() {
      this.cntrlfileurl = this.fileurl;
      this.getFiles();
    },
    uploadapi() {
      if (!this.uploadapi) this.cntrluploadapi = "/";
      this.cntrluploadapi = this.uploadapi;
    },
    autoupload() {
      this.cntrlautoupload = this.autoupload;
    },
    disabled() {
      this.cntrldisabled = this.disabled;
    },
  },
};
</script>

<style lang="scss" scope>
.large-icon-button {
  cursor: pointer;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.large-icon-button i {
  font-size: 30px;
}

.custom-dialog .el-dialog__headerbtn {
  font-size: 2em;
  margin-top: -20px;
}

.custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: red;
  font-weight: bold
}

.custom-upload .el-upload-list {
  display: flex;
  flex-wrap: wrap;
}

.custom-upload .el-upload-list__item {
  width: 50%;
}

.downloadable-list-container {
  display: flex;
  flex-wrap: wrap;
}

.downloadable-list {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}




.downloadable-list-item {
  width: 50%;
  box-sizing: border-box;
  padding: 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.button-container {
  margin-left: auto;
}

.hide .el-upload {
  display: none;
}
</style>
